module.exports = __webpack_public_path__ + "6c8a9e40d5b73b197c74ea07f885f0e4.svg";